import { UserEntity } from "../../entity/UserEntity";
import { LocalStoreService } from "../services/LocalStoreService";

export class UserDataAdapter {
    LocalStoreService = new LocalStoreService();
    constructor() {}
    user() {
        const localStorageService = new LocalStoreService();
        const user = localStorageService.getItem("nucont:user");
        if (!user) return null;
        const userEntity = UserEntity.restoreFromCloud(user);
        return userEntity.meteorModel;
    }
}
